// src/utils/dateUtils.js
export const calculateDaysTogether = (startedAt) => {
    if (!startedAt) return 0;
    
    const startDate = new Date(startedAt);
    const today = new Date();
    
    // 두 날짜 사이의 차이를 밀리초로 계산
    const diffTime = Math.abs(today - startDate);
    
    // 밀리초를 일로 변환
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
};

// "2026-08-01T14:30:00" → "8월 1일 14:30까지 유효"
export const formatExpiresAt = (expiresAt) => {
    const date = new Date(expiresAt);
    if (isNaN(date.getTime())) return '';
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${date.getMonth() + 1}월 ${date.getDate()}일 ${hours}:${minutes}까지 유효`;
};

export const isExpired = (expiresAt) => {
    const date = new Date(expiresAt);
    return isNaN(date.getTime()) || date.getTime() < Date.now();
};

export const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
};
